module.exports = __webpack_public_path__ + "img/SuperOK-StateWeHo.6b15f4f1.jpg";